import { useMemo } from 'react';

/**
 * usePercentSum — sums an array of percent values and reports validity
 * against a target (default 100). Used by QuoteSection's payment schedule
 * to drive both the live total indicator and the Save button gate from a
 * single source of truth.
 *
 * NaN entries are coerced to 0 (not poison sum).
 */

export interface PercentSumResult {
  total: number;
  isValid: boolean;
  diff: number; // target - total (positive = remaining, negative = over)
}

export function usePercentSum(values: number[], target: number = 100): PercentSumResult {
  return useMemo(() => {
    const total = values.reduce((sum, v) => sum + (Number.isFinite(v) ? v : 0), 0);
    return {
      total,
      isValid: total === target,
      diff: target - total,
    };
  }, [values, target]);
}
